import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "send_145755cbb105811af06db93dbd82c644",
  "use": "send_145755cbb105811af06db93dbd82c644-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"send_145755cbb105811af06db93dbd82c644\">\n    <path fill-rule=\"nonzero\" d=\"M7.49 3.838l12.96 7.29a1 1 0 0 1 0 1.744l-12.96 7.29A1 1 0 0 1 6 19.29v-5.927a.5.5 0 0 1 .461-.499L17.556 12 6.46 11.136A.5.5 0 0 1 6 10.637V4.71a1 1 0 0 1 1.49-.872z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol